import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Create } from "../../../groups";
import { Adapter } from "../../../../shared/adapter";
import { GroupRaw, Result } from "../../../../interfaces";
import { GroupAdapter } from "../../../../adapter/groups-adapter";

export const FETCH_CREATE_GROUPS_REQUEST = 'FETCH_CREATE_GROUPS_REQUEST';
export const FETCH_CREATE_GROUPS_SUCCESS = 'FETCH_CREATE_GROUPS_SUCCESS';
export const FETCH_CREATE_GROUPS_FAILURE = 'FETCH_CREATE_GROUPS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateGroupsRequest = () => {
    return {
        type: FETCH_CREATE_GROUPS_REQUEST,
    };
};

const fetchCreateGroupsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_GROUPS_SUCCESS,
        payload: data
    };
};

const fetchCreateGroupsFailure = (error: any) => {
    return {
        type: FETCH_CREATE_GROUPS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (group:GroupRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateGroupsRequest());
        try {
            const response = await Create(group);
            dispatch(fetchCreateGroupsSuccess(
                Adapter.from(response.data).to((value) => new GroupAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateGroupsFailure(error.message));
        }
    };
};
